module.exports = __webpack_public_path__ + "img/202501160401.7746d0c8.png";